import request from '@/utils/request'
//import fileDownload from 'js-file-download';
/**
 * 获得列表
 * @returns 
 */
export function getfontValue(viewid) {
    return request({
      url: `/api/app/view-entity/font-value`,
      params:{
        viewid:viewid
      },
      method: 'get',
    })
  }
  

  
/**
 * 获得列表
 * @returns 
 */
export function getView() {
    return request({
      url: `/api/app/view-entity`,
      method: 'get',
    })
  }

  export function getFileType(id) {
    let arr = [
      { type: "doc", application: "application/msword" },
      {
        type: "docx",
        application:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      },
      { type: "dot", application: "application/msword" },
      {
        type: "dotx",
        application:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.template"
      },
      { type: "xls", application: "application/vnd.ms-excel" },
      {
        type: "xlsx",
        application:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      },
      { type: "ppt", application: "application/vnd.ms-powerpoint" },
      {
        type: "pptx",
        application:
          "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      },
      { type: "pdf", application: "application/pdf" },
      { type: "txt", application: "text/plain" },
      { type: "gif", application: "image/gif" },
      { type: "jpeg", application: "image/jpeg" },
      { type: "jpg", application: "image/jpeg" },
      { type: "png", application: "image/png" },
      { type: "css", application: "text/css" },
      { type: "html", application: "text/html" },
      { type: "htm", application: "text/html" },
      { type: "xsl", application: "text/xml" },
      { type: "xml", application: "text/xml" },
      { type: "mpeg", application: "video/mpeg" },
      { type: "mpg", application: "video/mpeg" },
      { type: "avi", application: "video/x-msvideo" },
      { type: "movie", application: "video/x-sgi-movie" },
      { type: "bin", application: "application/octet-stream" },
      { type: "exe", application: "application/octet-stream" },
      { type: "so", application: "application/octet-stream" },
      { type: "dll", application: "application/octet-stream" },
      { type: "ai", application: "application/postscript" },
      { type: "dir", application: "application/x-director" },
      { type: "js", application: "application/x-javascript" },
      { type: "swf", application: "application/x-shockwave-flash" },
      { type: "xhtml", application: "application/xhtml+xml" },
      { type: "xht", application: "application/xhtml+xml" },
      { type: "zip", application: "application/zip" },
      { type: "mid", application: "audio/midi" },
      { type: "midi", application: "audio/midi" },
      { type: "mp3", application: "audio/mpeg" },
      { type: "rm", application: "audio/x-pn-realaudio" },
      { type: "rpm", application: "audio/x-pn-realaudio-plugin" },
      { type: "wav", application: "audio/x-wav" },
      { type: "bmp", application: "image/bmp" }
    ];
    return findArrayReturnValue(arr, "type", id, "application");
  }
  
/**
 * @param arr 查找数组
 * @param property 查找属性
 * @param value 查找值
 * @des:查找到值后返回其值
 */
export const findArrayReturnValue = (arr, property, value, findKey) => {
  let len, findValue;
  if (!Array.isArray(arr)) {
    return;
  }
  len = arr.length;
  for (var i = 0; i < len; i++) {
    if (
      Object.prototype.hasOwnProperty.call(arr[i], property) &&
      arr[i][property] == value &&
      Object.prototype.hasOwnProperty.call(arr[i], findKey)
    ) {
      findValue = arr[i][findKey];
      break;
    }
  }
  return findValue;
};

export const downloadZip = (fileArrayBuffer, filename) => {
  let data = new Blob([fileArrayBuffer], { type:'application/pdf'  });
  if (typeof window.chrome !== 'undefined') {
    // Chrome
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(data);
    link.download = filename;
    link.click();
    console.log(data);
  } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE
    var blob = new Blob([data], { type: 'application/pdf' });
    window.navigator.msSaveBlob(blob, filename);
  } else {
    // Firefox
    var file = new File([data], filename, { type: 'application/pdf'  });
    window.open(URL.createObjectURL(file));
  }
}


export function downdata(url,name){
  request.get(url, {
    responseType: 'blob',
  }).then(res => {
    console.log(res,'res')
    downloadZip(res, name+'.pdf');
  });
}


export function PrintQuery(value){
  return request({
    url: `/api/app/print_info/`+ value,
    method: 'get',
  })
}


/**
 * 签名pdf
 * @returns 
 */
export function signpdf(id,userid,objectarr) {
  return request({
    url: `/signpdf`,
    method: 'get',
    params:{
      viewId:id,
      userid:userid,
      objects:objectarr
    }
  })
}


export function getViewInfo(id){
  return request({
    url:`/api/app/view-entity/${id}`,
    method:'get'
  })
}

/**
 * 获取下载地址
 */
export function getDownload(id){
  return request({
    url:`/AuthorPdfPath?PrintId=${id}`,
    method:'get'
  })
}


/**
 * 获得列表
 * @returns 
 */
export function GroupByHYMC() {
  return request({
    url: `/api/identity/Yjscurrent/GroupByHYMC`,
    method: 'get',
  })
}


/**
 * 国合下载
 * @returns 
 */
export function GuoHeDownload(name,idnum) {
  return request({
    params:{
      name:name,
      idnum:idnum,
    },
    url: `/GetPdf`,
    method: 'get',
  })
}
